import request from '@/utils/request'

const getOrdersList = (params) => {
  return request({
    url: '/shop/orders',
    params,
    method: 'get'
  })
}

const getOrdersCount = (params) => {
  return request({
    url: '/shop/orders/count',
    params,
    method: 'get'
  })
}

const postOrder = (params) => {
  return request({
    url: '/shop/orders',
    data: params,
    method: 'post'
  })
}

const getOrderDetial = (id) => {
  return request({
    url: `/shop/orders/${id}`,
    method: 'get'
  })
}

const cancelOrder = (id, remark) => {
  return request({
    url: `/shop/orders/${id}/cancel`,
    data: remark,
    method: 'put'
  })
}

const receivedOrder = (id, remark) => {
  return request({
    url: `/shop/orders/${id}/received`,
    data: remark,
    method: 'put'
  })
}

const returnsOrder = (id, params) => {
  return request({
    url: `/shop/orders/${id}/returns`,
    data: params,
    method: 'put'
  })
}
export {
  getOrdersList, // 获取订单列表
  getOrdersCount, // 获取订单列表数量
  postOrder, // 下单
  getOrderDetial, // 订单详情
  cancelOrder, // 取消订单
  receivedOrder, // 确认收货
  returnsOrder // 申请售后
}
